import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
// import router from './router'
import {useRegistrationStore} from "@/stores/registration.ts";
import clickOutside from "@/directives/click-outside.ts";
const mountApp = () => {
    document.querySelectorAll('.company-registration').forEach((parentElement) => {
        const rootProps = { ...(parentElement as HTMLElement).dataset };

        Object.keys(rootProps).forEach((key: string) => rootProps[key] = JSON.parse(rootProps[key] ?? ''));

        try {
            const app = createApp(App, rootProps);

            app.use(createPinia())
            // app.use(router)
            app.mount(parentElement);

            app.directive("click-outside", clickOutside);
        }
        catch (error) {
            console.error("Error mounting Vue app on", parent, ":", error);
        }
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => mountApp());
}
else {
    mountApp();
}


//@ts-ignore
window.initMap =  () => {
    useRegistrationStore().googleService.initialized = true;
}
